$(function() {

    $('#projekte_carousel,#fortbildung_carousel,#ausbildung_carousel').owlCarousel({
      autoplayTimeout: 4000,
      loop: true,
      margin: 10,
      autoplay: true,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: { 
          items: 1,
          nav: false
        },
        991: {
          items: 1,
          nav: true
        },
        1500: {
          items: 1,
          nav: true,
          loop: true,
          margin: 20
        },
        1600: {
          items: 1,
          nav: true,
          loop: true,
          margin: 10
        }
      }
    });

    $('#kontakt_slider_carousel').owlCarousel({
      autoplayTimeout: 4000,
      loop: true,
      margin: 10,
      autoplay: true,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: { 
          items: 1,
          nav: false
        },
        768: {
          items: 1,
          nav: true
        },
        991: {
          items: 2,
          nav: true
        },
        1500: {
          items: 3,
          nav: true,
          loop: true,
          margin: 20
        },
        1600: {
          items: 3,
          nav: true,
          loop: true,
          margin: 10
        }
      }
    });

    

});